import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class CustomEmailsApi extends CollectionApi {
  constructor() {
    super('/api/v2/customemails', {
    });

    this.templatesUrl = '/api/v2/customemail/templates';
  }

  delete(type) {
    return axios.delete(`${this.baseUrl}/${type}`);
  }

  update(item) {
    return axios
      .put(`${this.baseUrl}/${item.type}`, item)
      .then((resp) => {
        if (resp && resp.data) return resp.data;
        return {};
      });
  }

  getTemplates() {
    return axios
      .get(this.templatesUrl)
      .then(resp => resp && resp.data);
  }
}

export default new CustomEmailsApi();
